export * from './related-product-set-new.component';
export * from './related-product-set-edit.component';
